/* Cœura collection filters & sort (Filters & Sort v1.1). Client-side over the grid's
   data-* attributes. Four facets: pieces (family) · type · metal · made-with-you, plus sort.
   OR within a facet, AND across facets. State lives in the URL (?pieces=…&metal=…&sort=…).
   Values are quiet text; the active line shows applied filters with an × each. No pills. */
(function () {
  'use strict';

  var bar = document.querySelector('[data-filterbar]');
  var grid = document.querySelector('[data-grid]');
  if (!bar || !grid) return;

  var activeEl = document.querySelector('[data-active]');
  var clearBtn = document.querySelector('[data-clear]');
  var emptyEl = document.querySelector('[data-empty]');
  var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-card]'));
  var vals = Array.prototype.slice.call(document.querySelectorAll('.filter-val'));

  var state = { pieces: [], type: [], metal: [], made: false, sort: 'featured' };

  function labelFor(facet, val) {
    var b = document.querySelector('.filter-val[data-facet="' + facet + '"][data-val="' + val + '"]');
    return b ? b.textContent.trim() : val;
  }

  /* ---- URL <-> state ---- */
  function readURL() {
    var q = new URLSearchParams(location.search);
    ['pieces', 'type', 'metal'].forEach(function (f) {
      var v = q.get(f); state[f] = v ? v.split(',').filter(Boolean) : [];
    });
    state.made = q.get('made') === '1';
    state.sort = q.get('sort') || 'featured';
  }
  function writeURL() {
    var q = new URLSearchParams();
    ['pieces', 'type', 'metal'].forEach(function (f) { if (state[f].length) q.set(f, state[f].join(',')); });
    if (state.made) q.set('made', '1');
    if (state.sort && state.sort !== 'featured') q.set('sort', state.sort);
    var qs = q.toString();
    history.replaceState(null, '', location.pathname + (qs ? '?' + qs : ''));
  }

  function anyFilter() { return state.pieces.length || state.type.length || state.metal.length || state.made; }

  /* ---- matching ---- */
  function matches(card) {
    if (state.pieces.length && state.pieces.indexOf(card.getAttribute('data-family')) === -1) return false;
    if (state.type.length && state.type.indexOf(card.getAttribute('data-type')) === -1) return false;
    if (state.metal.length) {
      var m = (card.getAttribute('data-metal') || '').split(/\s+/);
      if (!state.metal.some(function (x) { return m.indexOf(x) !== -1; })) return false;
    }
    if (state.made && card.getAttribute('data-made') !== '1') return false;
    return true;
  }

  /* ---- render ---- */
  function reorder() {
    var arr = cards.slice();
    if (state.sort === 'price-asc') arr.sort(function (a, b) { return (+a.getAttribute('data-price')) - (+b.getAttribute('data-price')); });
    else if (state.sort === 'price-desc') arr.sort(function (a, b) { return (+b.getAttribute('data-price')) - (+a.getAttribute('data-price')); });
    else arr.sort(function (a, b) { return (+a.getAttribute('data-i')) - (+b.getAttribute('data-i')); });
    arr.forEach(function (c) { grid.appendChild(c); });
  }

  function renderActive() {
    var chips = [];
    ['pieces', 'type', 'metal'].forEach(function (f) {
      state[f].forEach(function (v) { chips.push('<button type="button" class="active-chip" data-remove-facet="' + f + '" data-remove-val="' + v + '">' + labelFor(f, v) + ' <span aria-hidden="true">&times;</span></button>'); });
    });
    if (state.made) chips.push('<button type="button" class="active-chip" data-remove-facet="made" data-remove-val="1">Made with you <span aria-hidden="true">&times;</span></button>');
    activeEl.innerHTML = chips.join('');
    if (clearBtn) clearBtn.hidden = !anyFilter();
  }

  function syncButtons() {
    vals.forEach(function (b) {
      var f = b.getAttribute('data-facet'), v = b.getAttribute('data-val');
      var on = f === 'sort' ? state.sort === v
             : f === 'made' ? state.made
             : state[f].indexOf(v) !== -1;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function apply(animate) {
    function paint() {
      var shown = 0;
      cards.forEach(function (c) { var ok = matches(c); c.hidden = !ok; if (ok) shown++; });
      reorder();
      if (emptyEl) emptyEl.hidden = shown !== 0;
      grid.style.display = shown === 0 ? 'none' : '';
      renderActive(); syncButtons(); writeURL();
    }
    if (animate) {
      grid.classList.add('is-swapping');
      setTimeout(function () { paint(); grid.classList.remove('is-swapping'); }, 160);
    } else { paint(); }
  }

  /* ---- dropdowns (Filter · Sort) — two independent little menus ---- */
  var dropdowns = Array.prototype.slice.call(document.querySelectorAll('[data-fdrop]'));
  function closeMenus() {
    dropdowns.forEach(function (dd) {
      var m = dd.querySelector('[data-fdrop-menu]'), b = dd.querySelector('[data-fdrop-btn]');
      if (m) m.setAttribute('hidden', '');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  dropdowns.forEach(function (dd) {
    var btn = dd.querySelector('[data-fdrop-btn]');
    var menu = dd.querySelector('[data-fdrop-menu]');
    if (!btn || !menu) return;
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var willOpen = menu.hasAttribute('hidden');
      closeMenus();
      if (willOpen) { menu.removeAttribute('hidden'); btn.setAttribute('aria-expanded', 'true'); }
    });
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-fdrop]')) return;
    closeMenus();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenus(); });

  vals.forEach(function (b) {
    b.addEventListener('click', function () {
      var f = b.getAttribute('data-facet'), v = b.getAttribute('data-val');
      if (f === 'sort') { state.sort = v; }
      else if (f === 'made') { state.made = !state.made; }
      else { var i = state[f].indexOf(v); if (i === -1) state[f].push(v); else state[f].splice(i, 1); }
      apply(true);
      if (f === 'sort') closeMenus();  // sort is single-select — close the little menu after choosing
    });
  });

  if (activeEl) activeEl.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-remove-facet]'); if (!chip) return;
    var f = chip.getAttribute('data-remove-facet'), v = chip.getAttribute('data-remove-val');
    if (f === 'made') state.made = false;
    else { var i = state[f].indexOf(v); if (i !== -1) state[f].splice(i, 1); }
    apply(true);
  });

  if (clearBtn) clearBtn.addEventListener('click', function () {
    state.pieces = []; state.type = []; state.metal = []; state.made = false; state.sort = 'featured';
    apply(true);
  });

  readURL();
  apply(false);
})();
